import React from "react";
import { useTranslation } from "react-i18next";

const SkeletonTile = () => (
  <div className="flex min-h-[82px] items-center gap-3 rounded-[20px] bg-white px-3.5 py-3 shadow-sm">
    <div className="h-11 w-11 flex-shrink-0 rounded-2xl bg-line/70" />
    <div className="flex-1">
      <div className="h-3 w-20 rounded-full bg-line/70" />
      <div className="mt-2 h-2.5 w-14 rounded-full bg-line/50" />
    </div>
  </div>
);

const SkeletonHeading = () => (
  <div className="mb-3.5">
    <div className="h-4 w-24 rounded-full bg-line/80" />
  </div>
);

const DashboardSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen w-full animate-pulse bg-paper pb-24 font-sans"
      aria-busy="true"
      aria-label={t("dashboard.loading")}
    >
      <header className="sticky top-0 z-30 bg-white/95 shadow-sm">
        <div className="mx-auto flex max-w-lg items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-xl bg-primary/20" />
            <div>
              <div className="h-4 w-32 rounded-full bg-line" />
              <div className="mt-2 h-2.5 w-20 rounded-full bg-line/70" />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="h-11 w-14 rounded-xl bg-line/70" />
            <div className="h-11 w-11 rounded-xl bg-line/70" />
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-lg space-y-7 px-4 pb-4 pt-5" aria-hidden="true">
        <div className="rounded-[28px] bg-primary/25 p-5 shadow-sm">
          <div className="h-3 w-32 rounded-full bg-white/45" />
          <div className="mt-4 h-6 w-48 rounded-full bg-white/65" />
          <div className="mt-3 h-3 w-64 max-w-full rounded-full bg-white/40" />
          <div className="mt-5 h-[62px] rounded-[20px] bg-white/55" />
        </div>

        <section>
          <SkeletonHeading />
          <div className="grid grid-cols-2 gap-3">
            {[0, 1, 2, 3].map((item) => (
              <SkeletonTile key={item} />
            ))}
          </div>
        </section>

        <section>
          <SkeletonHeading />
          <div className="grid grid-cols-1 gap-3 min-[460px]:grid-cols-2">
            <SkeletonTile />
            <SkeletonTile />
          </div>
        </section>
      </main>
    </div>
  );
};

export default DashboardSkeleton;
